export default {
  login: 'Sign in',
  register: 'Sign up',
  forgotPassword: 'Forgot password',
  resetPassword: 'Reset password',
  home: 'Home',
  accountManage: 'Accounts',
  personalCenter: 'Personal center',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies',
  userList: 'User list',
  userDetail: 'User details',
  userVerificationConfig: 'Verification settings',
  userVerificationReviews: 'Verification reviews',
  memberPlan: 'Membership plans',
  memberPlanDetail: 'Plan details',
  rechargePackages: 'Recharge packs',
  rechargeMyPacks: 'My packs',
  rechargeRecords: 'Recharge history',
  adminRechargeRecords: 'Platform recharge records',
  adminRechargeOverview: 'Recharge overview',
  rechargeResourceManage: 'Recharge pack catalog',
  memberPlanOrders: 'Plan purchases',
  cloudSpace: 'Cloud storage',
  adminCloudSpace: 'Platform storage',
  companyPlanManage: 'Membership plan admin',
  companyPlanOrders: 'Activations',
  resourceGrantManage: 'Resource Grants',
  eventManage: 'Events',
  eventCreate: 'New event',
  eventEdit: 'Edit event',
  eventLocation: 'Location',
  eventRegistration: 'Registration',
  eventRegistrationSetup: 'Registration setup',
  eventShareTemplate: 'Share template',
  eventSchedule: 'Schedule',
  eventSeating: 'Seat editor',
  eventSeatQueryEditor: 'Seat query page',
  eventCheckin: 'Check-in management',
  votingManage: 'Voting management',
  registrationManage: 'Questionnaires',
  registrationFormEdit: 'Questionnaire designer',
  registrationProxyEntry: 'Contact entry',
  proxyRegistrationList: 'Contact entries',
  proxyOrders: 'Contact orders',
  proxyGrantConsume: 'Contact sign-in',
  proxyGrantLanding: 'Contact sign-in',
  proxyBridge: 'Contact sign-in',
  proxyEntryHint: 'Contact entry info',
  registrationH5: 'Registration',
  participantLogin: 'Participant sign in',
  participantRegister: 'Participant sign up',
  participantEmailVerify: 'Email verification',
  hotelManage: 'Hotels',
  eventMicrosite: 'Microsite',
  eventMicrositeEditor: 'Page editor',
  micrositeH5: 'Event microsite',
  micrositeAgendaH5: 'Schedule',
  seatQueryH5: 'Seat query',
  checkinH5: 'Event check-in',
  checkinScanDeskH5: 'Scan desk',
  checkinPrintDeskH5: 'Print desk',
  invitedIntro: 'Event site',
  invitedAgenda: 'Agenda',
  invitedRegistration: 'Register',
  invitedRecords: 'Reg. records',
  invitedOrders: 'Orders',
  albumCreate: 'New album',
  albumEdit: 'Edit album',
  photoManage: 'Photos',
  aiRetouch: 'AI retouch',
  baseInfo: 'Basic info',
  privacySettings: 'Privacy',
  shareSettings: 'Share settings',
  topPromotion: 'Top banner',
  launchPoster: 'Launch poster',
  loadingImage: 'Loading image',
  basicAd: 'Basic ad',
  bottomPromotionBar: 'Bottom bar',
  batchWatermark: 'Batch watermark',
  sideAd: 'Side ad',
  infoCard: 'Info card',
  largeImageDetail: 'Large image detail',
  photographerWorkbench: 'Photographer',
  retouchWorkbench: 'Retoucher',
  qcWorkbench: 'QC',
  auditorWorkbench: 'Auditor',
  workArea: 'Work area',
  defaultWorkflow: 'Default workflow',
  albumImages: 'Album images',
  forbidden: 'Access denied'
}
